import { render, staticRenderFns } from "./DSBillingFields.vue?vue&type=template&id=515d44d3&"
import script from "./DSBillingFields.vue?vue&type=script&lang=js&"
export * from "./DSBillingFields.vue?vue&type=script&lang=js&"
import style0 from "./DSBillingFields.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports